import React from 'react';
import styled from 'styled-components';
import {SIZES} from '@fupa/fupa-uikit';
import {oneOf} from 'prop-types';

const Goal = styled.div`
  display: flex;
  width: 100%;
  position: absolute;
  ${(props) => props.position}: ${SIZES['4']};
  left: 0;
  justify-content: center;
  opacity: 0.2;
  transform: ${(props) => (props.position === 'bottom' ? `rotate(180deg)` : 'none')};
`;

const PenaltyBox = ({position}) => {
  return (
    <Goal position={position}>
      <svg width='180' height='107' xmlns='http://www.w3.org/2000/svg'>
        <g fillRule='nonzero' stroke='#FFF' strokeWidth='4' fill='none'>
          <path d='M47 0v28h86V0M60 75c0 16.569 13.431 30 30 30 16.569 0 30-13.431 30-30' />
          <path d='M2 0v73h176V0' />
        </g>
      </svg>
    </Goal>
  );
};

PenaltyBox.propTypes = {
  position: oneOf(['bottom', 'top']),
};

PenaltyBox.defaultProps = {
  position: 'top',
};

export {PenaltyBox};
